<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    label: {
      type: String,
    },
    chartData: {
      type: Array,
    },
    options: {
      type: Object,
    },
  },
  mounted() {
    const emp_razon_social = this.chartData
      .map((d) => d.emp_razon_social)
      .reverse();
    const total_registros = this.chartData
      .map((d) => d.total_registros)
      .reverse();
    let colores = [];
    for (let i = 1; i < total_registros.length; i++) {
      colores.push("#" + ((Math.random() * 0xfff * i) << 0).toString(16));
    }

    this.renderChart(
      {
        labels: emp_razon_social,
        datasets: [
          {
            label: this.label,
            backgroundColor: colores,
            data: total_registros,
            borderColor: colores,
            borderWidth: 3,
          },
        ],
      },
      this.options
    );
  },
};
</script>
